import { useEffect, useState } from 'react';
import type { Catalog } from '../../lib/types';

export function useCatalog(): { catalog?: Catalog; error?: string } {
  const [catalog, setCatalog] = useState<Catalog>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    fetch('/.compass/catalog.json')
      .then(async (response) => {
        if (!response.ok) throw new Error(`catalog load failed: ${response.status}`);
        setCatalog((await response.json()) as Catalog);
      })
      .catch((err: unknown) => setError(err instanceof Error ? err.message : String(err)));
  }, []);

  return { catalog, error };
}
